import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';

import 'bootstrap/dist/css/bootstrap.min.css';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Levels from './components/Levels';
import Moregames from './components/games/Moregames';
import NewRiddleButton from './components/games/NewRiddleButton';

import tile1 from './static/tile1.png'
import tile2 from './static/tile2.png'
import tile3 from './static/tile3.png'
import logo from './icon.png'

import general from './static/json/general.json';
import server from './static/json/server.json';
import './static/css/style.css';

import { useNavigate } from "react-router-dom";

import ReactGA from 'react-ga4';
ReactGA.initialize('G-4J51X44PYF');


function checkIfFinished(id) {
	var score = localStorage.getItem('riddle-' + id + '-score');
    return (score != null);
}
function checkIfStarted(id) {
	var guesses = localStorage.getItem('guesses-' + id);
    return (guesses != null);
}

function MainPage({lang}) {
	const { t } = useTranslation();
	const navigate = useNavigate();

    return (
        <div className="mainPart">
        <Container>
          <Row>
            <div className="person-image">
                    <img src="/images/robot.png" alt="Who Am I Game" />
                  </div>
            <><h1>{t('title')}</h1>
    	    <p className="intro">{t('shortInstruction')}</p>
    	    <div>

    	    <NewRiddleButton lang={"en"} type={"main"} />

    	    </div></>

    	    <br/>
    	    <a href={"/" + lang + "/riddles"}>Show all riddles</a>
          </Row>

        </Container>
        </div>
      );
}

function MainPageBottom({lang}) {
	const { t } = useTranslation();
	const navigate = useNavigate();

    return (
        <div className="mainPart">
        <Container>
          <Row>
			<div className="person-image">
                    <img src="/images/robot2.png" alt="What Am I Game" />
                  </div>
            <><h1>{t('title')}</h1>
    	    <p className="intro">{t('shortInstruction')}</p>
    	    <div>

    	    <NewRiddleButton lang={"en"} type={"main"} />

    	    </div></>

    	     <br/>
    	    <a href={"/" + lang + "/riddles"}>Show all riddles</a>
          </Row>

        </Container>
        </div>
      );
}

function MoreInfo() {
	const { t } = useTranslation();
	return (
		<>
{ /*
			<Container>
				<br/>
				<Row>
                    <Col className="optionBox">
                        <img src="/images/games/guesser/img1.png" alt="Vocabulary" />
                        <h2>Expand Your Vocabulary </h2>
                        Discover and learn new words.
                    </Col>
                    <Col className="optionBox">
                        <img src="/images/games/guesser/img2.png" alt="Thinking" />
						<h2>Sharpen Your Thinking</h2>
						Improve logic and creative reasoning.
                    </Col>

                    <Col className="optionBox">
                        <img src="/images/games/guesser/img3.png" alt="Focus" />
                        <h2>Enhance Your Focus</h2>
                        Train your attention and word skills.

                    </Col>
                    <Col className="optionBox">
						<img src="/images/games/guesser/img4.png" alt="Persistence" />
						<h2>Build Persistence</h2>
						Practice patience through guessing.
                    </Col>

                    <Col className="optionBox">
                        <img src="/images/games/guesser/img5.png" alt="Progress" />
                        <h2>Track Your Progress </h2>
                        Watch yourself get better over time.

                    </Col>
                    <Col className="optionBox">
						<img src="/images/games/guesser/img6.png" alt="Smart Fun" />
						<h2>Enjoy Smart Fun</h2>
						Take a relaxing, brain-boosting break.
                    </Col>
                </Row>

			</Container>
			*/ }


			<Container className="moreInfo" >
				{/* <Row>

					<Col sm={3}>
						<img alt="example tile in tiles game"  src={"/images/games/guesser/pic1.png"} />
					</Col>
					<Col sm={9}>
						<h3>{t("gameHeader1")}</h3>
						<p>{t("gameText1")}</p>
					</Col>
				</Row>
				<Row>

					<Col sm={9}>
						<h3>{t("gameHeader2")}</h3>
						<p>{t("gameText2")}</p>
					</Col>

					<Col sm={3}>
						<img alt="example tile in tiles game"  src={"/images/games/guesser/pic2.png"} />
					</Col>
				</Row> */ }


				<Row>
					<Col sm={12}>
						<h3>{t("gameHeader1")}</h3>
						<p>{t("gameText1")}</p>
					</Col>
				</Row>

				<Row>
					<Col sm={12}>
						<h3>{t("gameHeader2")}</h3>
						<p>{t("gameText2")}</p>
					</Col>
				</Row>


				<Row>
					<Col sm={12}>
						<h3>{t("gameHeader3")}</h3>
						<p>{t("gameText3")}</p>
					</Col>

				</Row>
			</Container>

			<div className="mainPart">
				<Container className="instructionInfo">
					<Row>
						<Col sm={12}>
							<h2>{t("howToPlay")}</h2>
							<ol>
								<li><b>{t("instruction1title")} </b> <br/> {t("instruction1")}</li>
								<img className="smallInstruction" alt="Guess the word" src="/images/instruction/instruction1.png"/>

								<li><b>{t("instruction2title")} </b> <br/> {t("instruction2")}</li>
								<img className="bigInstruction" alt="Word guessing game" src="/images/instruction/instruction2.png"/>

								<li><b>{t("instruction3title")} </b> <br/> {t("instruction3")}</li>
								<img className="bigInstruction" alt="Guessie word challenge" src="/images/instruction/instruction3.png"/>
								<p><center>{t("instruction2more")} </center></p>

								<li><b>{t("instruction4title")} </b> <br/> {t("instruction4")}</li>

								<li><b>{t("instruction5title")} </b> <br/> {t("instruction5")}</li>
								<img className="smallInstruction" alt="Word game - guessed word" src="/images/instruction/instruction5.png"/>
								<p><center>{t("instruction3more")} </center></p>

								<li><b>{t("instruction6title")} </b> <br/> {t("instruction6")}</li>
								<img className="smallInstruction" alt="Word guessing game - statistics " src="/images/instruction/instruction6.png"/>

							</ol>
						</Col>
						<div>

			            </div><br/>


					</Row>
				</Container>
			</div>

			<Container className="moreInfo" >
				<Row>
					<Col sm={12}>
						<h3>{t("gameHeader4")}</h3>
						<p>{t("gameText4")}</p>
					</Col>

				</Row>
				<Row>
					<Col sm={12}>
						<h3>{t("gameHeader5")}</h3>
						<p>{t("gameText5")}</p>
					</Col>

				</Row>
				<Row>
					<Col sm={12}>
						<h3>{t("gameHeader6")}</h3>
						<p>{t("gameText6")}</p>
					</Col>

				</Row>
			</Container>



		</>
	);
}



function Main({lang}) {

	const { t } = useTranslation();
	const langBasic = (lang == "en") ? "" : lang;
	const description = t("description");
	const title = "Guessie - " + t("titleShort");

	return (
		<>
			<Helmet>
                <title>{title}</title>
                <link rel="canonical" href={"https://www.guessie.com/" + langBasic} />
                <meta property="og:url" content={"https://www.guessie.com/" + langBasic}  data-react-helmet="true" />

                <meta name="description" content={description}/>

                <meta property="og:image" content="https://www.guessie.com/banner.png" />
                <meta property="og:title" content={title}/>
                <meta property="og:description" content={description}/>

            </Helmet>
			<MainPage lang={lang}/>
			<MoreInfo/>
			<MainPageBottom lang={lang}/>


			{ /*
			 <div className="mainPart">
                <Container>
                    <Moregames/>
                </Container>
            </div> */ }
		</>

	);
};

export default Main;
